import React, { useState } from 'react';
import { Tabs } from 'antd';
import Layout from '../../components/Layout';
import CustomersList from '../CustomerManagementReports/CustomersList';

import './styles.css';

const CorporateCustomerManagement = () => {
  const [activeTab, setActiveTab] = useState('customers');

  const items = [
    {
      key: 'customers',
      label: 'Corporate Customers',
      children: <CustomersList userType="CORPORATE" />,
    }
  ];

  return (
    <Layout>
      <div style={{ padding: '0 24px' }}>
        <h1 style={{ marginBottom: 24, fontSize: '24px', fontWeight: '600' }}>Corporate Reports</h1>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={items}
          className="corporate-tabs"
          destroyOnHidden
        />
      </div>
    </Layout>
  );
};

export default CorporateCustomerManagement;
